import { Observable } from 'rxjs';
import { MyNavigator } from 'typings/globals/cordova';

import { ForegroundGeolocationPlugin } from './ForegroundGeolocationPlugin';
import { IpGeolocationPlugin } from './IpGeolocationPlugin';
import { LocationPermissions } from './Permissions';

declare const navigator: MyNavigator;

const InUseLocationPluginEnabled = () => true;

export interface GeoPoint {
  longitude: number;
  latitude: number;
}
export type LocationDataSource = 'GPS' | 'IP';
export type LocationSourceQuality = 'STREET' | 'CITY' | 'COUNTRY';

export interface LocationInfo {
  location: GeoPoint;
  source: LocationDataSource;
  quality: LocationSourceQuality;
}

export interface LocationSource {
  getLocation: () => Promise<LocationInfo>;
  source$: Observable<LocationInfo>;
}

export function sourceValue(a: LocationSourceQuality): number {
  switch (a) {
    case 'STREET':
      return 2;
    case 'CITY':
      return 1;
    case 'COUNTRY':
      return 0;
  }
  return -1;
}

const ipBased = new IpGeolocationPlugin();
const inUseGps = new ForegroundGeolocationPlugin();

export function retrieveLocation(
  permissions?: LocationPermissions,
  byIP = false,
): Promise<LocationInfo> {
  if (
    permissions &&
    permissions.inUse &&
    navigator.geolocation &&
    InUseLocationPluginEnabled() &&
    permissions.gpsEnabled &&
    !byIP
  ) {
    console.log('retrieveLocation in-use');
    return inUseGps.getLocation();
  }
  console.log('retrieveLocation no-permission');
  return ipBased.getLocation();
}

export const Location$: Observable<LocationInfo> = Observable.merge(
  ipBased.source$,
  inUseGps.source$,
)
  .scan((prev, next) => {
    if (prev && next && sourceValue(prev.quality) > sourceValue(next.quality)) {
      console.debug(
        `Location$ ignoring new location point, not good quality `,
        next,
      );
      return prev;
    }
    return next;
  })
  .shareReplay(1);

Location$.subscribe((l) => {
  console.debug('Location$', l);
});
